<template>
  <div class="group-team-container">
    <div class="action-header">
    <el-row>
      <el-button
        type="primary"
        @click="handleAdd" >添加球队</el-button>
      <el-button
        type="primary"
        @click="exportTeamsPDF" >导出该组别秩序册</el-button>
        <el-upload 
            :action="importAction"
            name="content"
            :show-file-list="false"
            :on-success="handleImportSuccess"
            :on-error="handleImportError"
        >
          <el-button type="primary" @click="handleImport">导入球队</el-button>
        </el-upload>
        <el-button @click="handleDownloadTemplate">下载球队模板</el-button>
    </el-row>
    </div>
    <el-table
      v-loading="listLoading"
      :data="list"
      style="width: 100%"
      @selection-change="handleSelectionChange">
      <!--<el-table-column-->
      <!--type="selection"-->
      <!--width="55">-->
      <!--</el-table-column>-->
      <el-table-column
        prop="name">
        <template slot="header" slot-scope="scope">
          <div>球队名称</div>
          <el-input
            v-model="search.name"
            placeholder="搜索"
            @change="quickSearch"/>
        </template>
        <template slot-scope="scope">
          <el-button type="text" @click="routerTeamPlayer(scope.row.id)">{{ scope.row.longName + '(' + scope.row.name + ')' }}</el-button>
        </template>
      </el-table-column>
      <el-table-column
        label="所属会员单位"
        prop="organization.name"/>
      <el-table-column
        :formatter="formatAudit"
        width="160"
        prop="auditStatus">
        <template slot="header" slot-scope="scope">
          <div>审核状态</div>
          <el-select v-model="search.auditStatus" placeholder="请选择" @change="quickSearch">
            <el-option
              v-for="item in auditStateList"
              :key="item.value"
              :label="item.label"
              :value="item.value"/>
          </el-select>
        </template>
      </el-table-column>

      <el-table-column
        :formatter="formatState"
        width="120"
        prop="status">
        <template slot="header" slot-scope="scope">
          <div>状态</div>
          <el-select v-model="search.status" placeholder="请选择" @change="quickSearch">
            <el-option
              v-for="item in stateList"
              :key="item.value"
              :label="item.label"
              :value="item.value"/>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column
        label="球员数量"
        align="center"
        width="120"
        prop="playerCount"/>
      <el-table-column
        label="是否弃权"
        align="center"
        width="120"
      >
        <template slot-scope="{ row }">
          <el-select v-model="row.isAbstention" @change="change(row.groupId, row.id, row.isAbstention)">
            <el-option :value="0" label="正常"/>
            <el-option :value="-1" label="弃权"/>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column
        label="参赛成绩"
        align="center"
        width="120"
      >
        <template slot-scope="{ row }">
          <el-select v-model="row.result" @change="changeTeamResult(row.groupId, row.id, row.result)">
            <el-option :value="0" label="无"/>
            <el-option :value="1" label="第1名"/>
            <el-option :value="2" label="第2名"/>
            <el-option :value="3" label="第3名"/>
            <el-option :value="4" label="第4名"/>
            <el-option :value="5" label="第5名"/>
            <el-option :value="6" label="第6名"/>
            <el-option :value="7" label="第7名"/>
            <el-option :value="8" label="第8名"/>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        width="250"
        algin="right">
        <template slot-scope="scope">
          <el-button
            size="mini"
            @click="routerTeamPlayer(scope.row.id)">球员管理</el-button>
          <!--<el-button-->
          <!--size="mini"-->
          <!--@click="routerTeamPlayer(scope.row.id)">球员管理</el-button>-->
          <el-button
            size="mini"
            type="danger"
            @click="handleDelete(scope.$index, scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="table-footer">
      <!--<el-button  style="position: absolute;left: 15px;top: 0;"-->
      <!--@click="exportTeamsPDF"-->
      <!--type="primary" >导出秩序册</el-button>-->
      <el-pagination
        v-show="totalCount>0"
        :current-page="currentPage"
        :page-size="pageSize"
        :total="totalCount"
        background
        layout="total, sizes, prev, pager, next"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"/>
    </div>

    <el-dialog
      :visible.sync="dialogVisible"
      class="main"
      title="添加球队"
      width="50%">
      <div>
        <el-form
          label-width="80px">
          <el-form-item label="球队名称" >
            <el-input v-model="dialogForm.longName" placeholder="请输入名称" />
          </el-form-item>
          <el-form-item label="球队简称" >
            <el-input v-model="dialogForm.name" placeholder="请输入简称" />
          </el-form-item>
          <el-form-item v-if="allowTeamSignup" label="审核状态">
            <el-radio-group v-model="dialogForm.auditStatus">
              <el-radio :label="0">待审核</el-radio>
              <el-radio :label="2">通过</el-radio>
              <el-radio :label="1">未通过</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="状态" >
            <el-radio-group v-model="dialogForm.status">
              <el-radio :label="0">正常</el-radio>
              <el-radio :label="-1">禁用</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button :loading="listLoading" type="primary" @click="newTeam">确 定</el-button>
      </span>
    </el-dialog>
    <!-- create/edit modal start -->
  </div>
</template>

<script>

import find from 'lodash/find'
import { updateTeam, createTeam, getMatchGroupTeamList, getMatchInfo,
  matchStateList, auditStatus, exportGroupTeams, adminUpdateMatchGroupTeam, getMatchGroupTeamResultList, updateMatchGroupTeamResult, getImportGroupTeamUrl, getImportGroupTeamTemplateUrl } from '@/api/match'
import { showMessage } from '@/utils'

const defaultForm = {
  auditStatus: 2,
  status: 0
}

export default {
  name: 'GroupTeamList',
  data() {
    return {
      search: {},
      list: [],
      totalCount: 0, // 默认数据总数
      pageSize: 20, // 每页的数据条数
      currentPage: 1, // 默认开始页面
      listQuery: {},
      listLoading: false,
      roleList: [],
      isEditMode: false,
      modalTitle: '',
      dialogForm: {},
      dialogVisible: false,
      dialogVisibleNewTeam: false,
      auditStateList: [],
      createTeamStatus: [],
      rules: {
        mobile: [
          { required: true, message: '请输入登录账号', trigger: 'blur' },
          { pattern: /^1\d{10}$/, message: '目前只支持中国大陆的手机号码' }
        ],
        membershipTypeId: [
          { required: true, message: '请选择用户身份', trigger: 'blur' }
        ]
      },
      leagueId: Number,
      routerParams: {},
      allowTeamSignup: 0,
      multipleSelection: []
    }
  },
  computed: {
      importAction() {
          return getImportGroupTeamUrl(this.routerParams.gid)
      }
  },
  created() {
    this.routerParams = this.$route.params
    if (this.routerParams.gid) {
      this.getList()
      this.getMatchInfo()
    }
    this.getAuditList()
  },
  methods: {
    handleImportError() {
        showMessage('error', '导入失败')
    },
    handleImport() {
        this.listLoading = true
    },
    handleImportSuccess(response) {
        // console.log('handleImportSuccess', arguments)
        this.listLoading = false
        if (response.ok) {
            showMessage('success', '导入成功，共' + response.messages.affectedTeams + '只球队，共' + response.messages.affectedRows + '位球员')
            this.getList()
        }
        else {
            showMessage('error', '导入失败')
        }
    },
    handleDownloadTemplate() {
        window.open(getImportGroupTeamTemplateUrl(), '_blank')
    },
    changeTeamResult(groupId, teamId, value) {
        console.log('@changeTeamResult', groupId, teamId, value)
        updateMatchGroupTeamResult({groupId: groupId, teamId: teamId}, {result: value}).then(res => {
        if (res) {
          this.getList()
        }
      })
    },
    change(groupId, teamId, value) {
      const params = { groupId, teamId, value }
      adminUpdateMatchGroupTeam(params).then(res => {
        if (res) {
          this.getList()
        }
      })
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getList()
    },
    handleAdd() {
      this.dialogVisible = true
      this.isEditMode = false
      this.modalTitle = '添加用户信息'
      this.dialogForm = Object.assign({}, defaultForm)
    },
    handleDelete(index, row) {
      this.$confirm('此操作将永久删除该球队, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      }).then(() => {
        this.deleteMatchTeam(this.list[index].id)
      }).catch(() => {
      })
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getList()
    },
    quickSearch() {
      this.getList()
    },
    getList() {
      this.listLoading = true
      this.listQuery = {
        pageNum: this.currentPage,
        pageSize: this.pageSize,
        groupId: this.routerParams.gid
      }
      this.listQuery = Object.assign(this.listQuery, this.search)
      getMatchGroupTeamList(this.listQuery).then(response => {
        console.log('@getMatchGroupTeamList', this.listQuery)
        getMatchGroupTeamResultList({id: this.listQuery.groupId}).then(res => {
            console.log('@getMatchGroupTeamResultList', res)
            const teamResults = res
            const data = response.data
            for (let i = 0; i < data.list.length; i++) {
                let item = data.list[i]
                for (let j = 0; j < teamResults.length; j++) {
                    let teamResult = teamResults[j]
                    if (item.id == teamResult.teamId) {
                        item.result = teamResult.result
                    }
                }
            }
            this.list = data.list
            this.currentPage = data.pageNum
            this.totalCount = data.count
            this.listLoading = false
        })
      })
    },
    deleteMatchTeam(userId) {
      const params = {
        groupId: this.routerParams.gid,
        teamId: userId,
        status: -2
      }
      updateTeam(params).then(response => {
        const data = response.data
        if (data) {
          this.$message({
            message: '删除成功',
            type: 'success',
            showClose: true,
            duration: 1000
          })
          this.getList()
        }
      })
    },
    getMatchInfo() {
      const params = {
        id: this.routerParams.id
      }
      getMatchInfo(params).then((res) => {
        const data = res.data
        if (data && data.match) {
          this.allowTeamSignup = data.match.allowTeamSignup
        }
      })
    },
    getAuditList() {
      this.stateList = matchStateList
      this.auditStateList = auditStatus
    },
    formatAudit: function(row, column) {
      const value = row[column.property]
      const obj = find(this.auditStateList, function(item) {
        return item.value === value
      })
      return obj && obj.label
    },
    formatState: function(row, column) {
      const value = row[column.property]
      const obj = find(this.stateList, function(item) {
        return item.value === value
      })
      return obj && obj.label
    },
    newTeam() {
      this.listLoading = true
      this.dialogForm.groupId = this.routerParams.gid
      if (!this.dialogForm.name) {
        this.$message({
          message: '球队简称不能为空',
          type: 'error',
          showClose: true,
          duration: 1000
        })
        this.listLoading = false
        return
      }
      const len = this.getStrLength(this.dialogForm.name)
      if (this.dialogForm.name && len > 10) {
        this.$message({
          message: '球队简称长度不能大于5个中文字符',
          type: 'error',
          showClose: true,
          duration: 1000
        })
        this.listLoading = false
        return
      }
      createTeam(this.dialogForm).then((resolve) => {
        this.listLoading = false
        if (resolve) {
          this.dialogVisible = false
          this.getList()
          this.$message({
            message: '创建球队成功',
            type: 'success',
            showClose: true,
            duration: 1000
          })
        }
      })
    },
    getStrLength(str) {
      var cArr = str.match(/[^\x00-\xff]/ig)
      return str.length + (cArr == null ? 0 : cArr.length)
    },
    routerTeamPlayer(id) {
      this.$router.push({
        name: 'LeagueGroupTeamPlayers',
        params: {
          id: this.routerParams.id,
          tid: id
        }
      })
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    exportTeamsPDF() {
      const params = {
        groupId: this.routerParams.gid
      }
      exportGroupTeams(params).then((resolve) => {
        const data = resolve.data
        if (data && data.email) {
          // window.open(process.env.BJH_API + decodeURIComponent(data.url), '_blank')
          this.$message({
            message: '导出数据成功，请在邮箱:' + data.email + '查收',
            type: 'success',
            showClose: true,
            duration: 1000
          })
        }
      })
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss">
  .group-team-container {
    margin: 30px 15px;
    .action-header {
        padding: 0 10px 10px 10px;
        .el-row {
          .el-button,.el-upload,div {
            display: inline-block;
          }
        }
      }
    .el-table {
      th {
        div {
          line-height: 20px;
        }
        .el-select {
          padding-left: 0;
          padding-right: 0;
          .el-input {
            padding-left: 0;
            padding-right: 0;
          }
        }
      }
    }

    .table-footer {
      text-align: center;
      margin-top: 30px;
      position: relative;
    }

    .el-date-editor.el-input {
      width: 140px;
    }

    .el-input__prefix {
      left: 10px
    }

    .el-input__suffix {
      right: 10px;
    }

    .el-input--prefix .el-input__inner {
      padding-left: 25px;
      padding-right: 20px;
    }

    .demonstration {
      display: block;
      padding-bottom: 15px;
    }

    .input-win {
      width: 200px !important;
    }

    .input-win .el-input__prefix {
      left: 5px;
    }

    .main .el-dialog__body {
      padding: 0 20px;
    }

    .main .el-form-item__label {
      text-align: left;
    }

    .el-button--text {
      color: #606266
    }
    .el-button--text:hover {
      color: #409EFF;
      text-decoration: underline;
    }
    .el-button+.el-button {
      margin-left: 0;
    }

  }
</style>
